import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { PAGE_CONTACT } from '../../config/pages';

import ContactForm from './contact/ContactForm';
import FooterSmall from './common/FooterSmall';
import ContactMap from './contact/ContactMap';
import { companyInfoPropsType, getCmsTopicList } from '../helpers/fetchCmsContent';
import NurturingForm from './contact/NurturingForm';
import Directus from '../helpers/directusLink';

const Contact = ({
    t, openPage, language, page, consents, claim, companyInfo
}) => {
    const [topics, setTopics] = useState([]);

    useEffect(() => {
        const fetchContent = async () => {
            const responseTopics = await getCmsTopicList(language);
            setTopics(responseTopics);
        };
        fetchContent();
    }, [language]);

    const contactDetails = useMemo(() => {
        if (!companyInfo) {
            return {
                street: '',
                zip_code: '',
                town: '',
                vatIdName: '',
                vatIdNumber: '',
                shortName: '',
                fullName: ''
            };
        }

        const companyRegistrationNumber = companyInfo.company_registration_number
            .map(({ translations, ...el }) => ({ ...el, ...Directus.getTranslationByLang(translations) }))
            .find((el) => el.company_registration_number_id === 1);

        return {
            street: companyInfo.street,
            zip_code: companyInfo.zip_code,
            town: companyInfo.town,
            vatIdName: companyRegistrationNumber ? companyRegistrationNumber.name : '',
            vatIdNumber: companyRegistrationNumber ? companyRegistrationNumber.number : '',
            shortName: companyInfo.short_name,
            fullName: companyInfo.full_name

        };
    }, [language, companyInfo]);

    const contactClassName = cx('container-contact', {
        open: page === PAGE_CONTACT
    });

    return (
        <div>
            <div className={ contactClassName } id={ contactClassName }>
                <div className="layout">
                    <div className="section-title" id="section-title-contact">
                        <h1 dangerouslySetInnerHTML={ { __html: t('contact.title') } }/>
                    </div>
                    <div className="page-contact" id="page-contact">
                        <div className="page-contact-form" id="page-contact-form">
                            <div className="contact-title" id="contact-title">{ t('contact.form.title') }</div>
                            <ContactForm t={ t } language={ language } consents={ consents } topics={ topics }/>
                        </div>
                        <div className="page-contact-content" id="page-contact-content-01">
                            <div className="contact-list" id="contact-list-01">
                                <div className="contact-nurturing-form" id="nurturing-form"/>
                                <div className="contact-title" id="contact-title-01">{ t('contact.people.title') }</div>
                                <NurturingForm t={ t } language={ language } consents={ consents } topics={ topics }/>
                            </div>
                            <div className="contact-list" id="contact-list-02">
                                <div className="contact-title" id="contact-title-02">{ t('contact.headquarter.title') }</div>
                                <div className="contact-elem" id="contact-elem-02">
                                    <div className="contact-avatar" id="contact-avatar-01">
                                        {
                                            process.env.DEFAULT_LANGUAGES === 'de' ? (
                                                <img
                                                  src={ require('../../assets/images/footer/headquarter-avatar-128-de.jpg') }
                                                  srcSet={
                                                    `${ require('../../assets/images/footer/headquarter-avatar-128-de.jpg') } 1x,
                                                    ${ require('../../assets/images/footer/headquarter-avatar-256-de.jpg') } 2x` }
                                                  alt={ contactDetails.fullName }
                                                />
                                            ) : (
                                                <img
                                                  src={ require('../../assets/images/footer/headquarter-avatar-128.jpg') }
                                                  srcSet={
                                                    `${ require('../../assets/images/footer/headquarter-avatar-128.jpg') } 1x,
                                                    ${ require('../../assets/images/footer/headquarter-avatar-256.jpg') } 2x` }
                                                  alt={ contactDetails.fullName }
                                                />
                                            )
                                        }
                                    </div>
                                    <div className="contact-details" id="contact-details">
                                        <div className="contact-name" id="contact-name-03">{ t('contact.headquarter.address.company') }</div>
                                        {companyInfo &&
                                        <div className="contact-text" id="contact-text-03">
                                            ul. { contactDetails.street }<br/>
                                            { contactDetails.zip_code } {contactDetails.town}
                                            {' '}
                                            { t('contact.headquarter.address.country') }<br/>
                                            { <a href={ `tel:${ companyInfo.phone }` }> {companyInfo.phone} </a>}
                                            <br/>
                                            { contactDetails.vatIdName }
                                            {': '}
                                            { contactDetails.vatIdNumber }<br/>
                                            {
                                                t('contact.headquarter.address.note').length > 0 && <a
                                                  href="https://sagiton.pl"
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="note"
                                                  id="note-01"
                                                  dangerouslySetInnerHTML={ { __html: t('contact.headquarter.address.note') } }
                                                />
                                            }
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ContactMap
                      t={ t }
                      language={ language }
                    />
                </div>
            </div>
            <FooterSmall t={ t } language={ language } openPage={ openPage } claim={ claim }/>
        </div>
    );
};

Contact.defaultProps = {
    companyInfo: null
};

Contact.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    consents: PropTypes.objectOf(Object).isRequired,
    claim: PropTypes.string.isRequired,
    companyInfo: companyInfoPropsType
};

export default Contact;



// WEBPACK FOOTER //
// ./src/components/content/Contact.jsx